import BasicLayout from '@/layouts/basic-layout';
////第一步：配置菜单-->第二步：配置存房委托渠道指派专员页面相关的路由-->第三步：注入路由-->第四步：做页面
const meta = {
	auth: true
};

const pre = 'khm-';

export default {
	path: '/khm',
	name: '指派评估专员',//存房委托渠道指派专员
	redirect: {
		name: `${pre}houseSaveChannelAssessment-list`
	},
	meta,
	component: BasicLayout,
	children: [{
		path: 'houseSaveChannelAssessment-list',
		name: `${pre}houseSaveChannelAssessment-list`,
		meta: {
			...meta,
			title: '指派评估专员',
			closable: true
		},
		component: () => import('@/pages/storagemanage/houseSaveChannelAssessment/index')
	}]
};
